<template>
  <div class="option-list-container">
    <!-- 总览 -->
    <vote-summary :data="data" v-if="voteType == 1" style="margin-top: 20px"></vote-summary>
    <!-- 搜索 -->
    <div class="search-container">
      <van-search v-model="apiParams.keyword" placeholder="请输入选项名称进行搜索" @search="onSearch" @clear="onClear" />
      <div slot="action" @click="onSearch" class="search-btn"></div>
    </div>
    <!-- 投票提示 -->
    <vote-tip :data="data" :isEnded="isEnded"></vote-tip>
    <!-- 选项列表 -->
    <van-list v-if="list.length > 0" v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad"
      :offset="300">
      <!-- 单选 -->
      <div class="option-container" v-if="type == '1'">
        <div class="option" v-for="(val, index) in list" :key="index">
          <div class="option-cnt" @click="toVoteDetail(index)">
            <div class="option-avatar flexbox" v-if="val.pic && option_type == 1">
              <img class="option-pic" :src="`${val.pic}`" :class="{ gray: val.style == 1 }" alt />
            </div>
            <div class="option-title" :class="{ bb: val.style == 1 }">
              <p>{{ val.title }}</p>
            </div>
            <div class="option-count" v-if="showAllTickets()">{{ val.count }}{{ showText }}</div>
            <div class="opa-icon" v-if="number_display == 1">{{ val.inner_id }}号</div>
          </div>
          <div class="option-btn-group" :class="{ tac: !val.pic }">
            <SingleVoteButton :maxCount="data.surplus_ticket" :disabled="isEnded" :voteText="voteText"
              :activeTab="activeTab" :index="index" @single-vote="handleSingleVote">
            </SingleVoteButton>
          </div>
        </div>
      </div>
      <!-- 多选 -->
      <div class="option-container multi" v-if="type == '2'">
        <van-checkbox-group v-model="multiResult">
          <div class="option" v-for="(val, index) in list" :key="index">
            <div class="option-cnt" @click="toVoteDetail(index)">
              <div class="option-avatar flexbox" v-if="val.pic && option_type == 1">
                <img class="option-pic" :src="`${val.pic}`" :class="{ gray: val.style == 1 }" alt />
              </div>
              <div class="option-title" :class="{ bb: val.style == 1 }">
                <p>{{ val.title }}</p>
              </div>
              <div class="option-count" v-if="showAllTickets()">{{ val.count }}{{ showText }}</div>
              <div class="opa-icon" v-if="number_display == 1">{{ val.inner_id }}号</div>
            </div>
            <div class="option-btn-group" :class="{ tac: !val.pic }" @click="toggle(index)">
              <van-checkbox ref="checkboxes" :name="val" :disabled="isEnded || overSelected">{{ val.btn_text }}
              </van-checkbox>
            </div>
          </div>
        </van-checkbox-group>
        <div class="multi-btn-group" v-if="optionListIndex == activeTab && !popShow">
          <span>已选{{ multiResult.length }}个</span>
          <!-- :disabled="multiResult.length < this.vote_min || multiResult.length > this.vote_max" -->
          <van-button round type="info" class="multi-vote-btn" @click="getVoteStarted">{{ voteText }}</van-button>
        </div>
      </div>
    </van-list>
    <!-- 无数据 -->
    <div v-if="!list.length && !isLoading" class="no-cnt"></div>
    <!-- 选项详情改为组件 -->
    <van-popup v-model="popShow" position="right">
      <option-detail v-if="popShow" :detailParams="detailParams" :isEnded="isEnded" @close-pop="closePop"
        @single-vote="handleSingleVote">
      </option-detail>
    </van-popup>
    <!-- 微信提示 20220701 重新开启 -->
    <div class="open_browser" v-if="showMask" @click="showMask = !showMask">
      <img src="../assets/images/open-tip.png" alt />
    </div>
    <!-- 投票后弹窗 -->
    <PopAfter :showModal="showModal" :popVoteInfo="popVoteInfo" @closePopAfter="handleClosePopAfter"></PopAfter>
    <!-- 加载 -->
    <Loading v-show="isLoading"></Loading>
  </div>
</template>

<script>
import axios from "axios";
/* 提示弹窗 */
import { Dialog } from "vant";
/* js BRIDGE */
import { WebBridgeApi } from "ijsbridge";
import { createCaptcha } from 'xt-captcha';
import { isWechat, isApp, launchApp, launchAppSD, getSpeToken } from '../utils/utils';
import { tracking } from '../utils/tracking';
/*  */
import OptionDetail from "./OptionDetail";
import VoteSummary from "./VoteSummary";
import VoteTip from "./VoteTip";
import SingleVoteButton from "./SingleVoteButton";
import Loading from "./Loading";
import PopAfter from "./PopAfter";

export default {
  name: "OptionList",
  props: {
    id: {
      type: String,
      default: "",
    },
    data: {
      type: Object,
      default: () => { },
    },
    // 组合投票，查看详情时的头图
    coverPic: {
      type: String,
      default: "",
    },
    // 投票活动类型，0 单一，1 组合
    voteType: {
      type: String,
      default: "0",
    },
    // 投票方式，1 单选，2 多选
    type: {
      type: String,
      default: null,
    },
    isEnded: {
      type: Boolean,
      default: false,
    },
    // 多选提示按钮相关
    activeTab: {
      type: Number,
      default: null,
    },
    // 多选提示按钮相关
    optionListIndex: {
      type: Number,
      default: null,
    },
    /* 新微信逻辑 */
    wechatPreviewOnly: {
      // 微信仅可预览
      type: Boolean,
      default: false,
    },
    // 微信可投票
    wechatCanVote: {
      type: Boolean,
      default: false,
    },
    weixinJumpUrl: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      // 渲染列表
      list: [],
      // 请求接口
      apiParams: {
        id: this.id,
        page: 1,
        size: 10,
        keyword: "",
        isPreview: 0,
      },
      // 加载
      loading: false,
      // 加载是否完成
      finished: false,
      // 仅单选，当前选项
      curIndex: null,
      // 单选生效，每个选项最多可投多少票
      ticket: 1,
      // 多选
      multiResult: [],
      // 多选结果（UI）
      vote_min: null,
      vote_max: null,
      // 选项类型 1 图文 2 纯文字
      option_type: 1,
      // 是否展示选项编号
      number_display: 1,
      // 单、多选结果（数据）
      option_ids: [],
      // 投票query
      votePayload: {},
      // 微信遮罩层
      showMask: false,
      // 详情页弹出
      popShow: false,
      // 详情页参数
      detailParams: {
        cover_pic: "",
        inner_id: "",
        pic: "",
        title: "",
        count: "",
        des: "",
        type: "",
        index: ""
      },
      // 浏览器头
      ua: navigator.userAgent.toLowerCase(),
      // 按钮文字
      voteText: "投票",
      // 展示用文字 票 or 赞
      showText: "票",
      // 验证码对象
      captcha: null,
      // 验证码模式
      captchaMode: "slide", // slide or text 
      // 验证码
      verifyData: "",
      // 看不懂vant的列表组件，用这个参数控制吧
      isLoading: false,
      // 投票后业务弹窗
      showModal: false,
      // 投票后业务弹窗参数
      popVoteInfo: null,
      // 用户是否已经通过分享查看过选项详情
      hasOpened: false,
    };
  },
  components: {
    VoteSummary,
    VoteTip,
    OptionDetail,
    SingleVoteButton,
    Loading,
    PopAfter
  },
  watch: {
    activeTab: {
      handler: function () {
        this.multiResult = []
        this.option_ids = []
        this.curIndex = null
        this.initOnLoadParams()
        this.onLoad()
      },
      deep: true,
    }
  },
  computed: {
    overSelected() {
      // return this.result.length >= this.vote_max
    },
    isWechat() {
      return isWechat()
    },
    isApp() {
      return isApp()
    },
    isPreview() {
      return this.$utils.getUrlParams("isPreview") || this.$store.state.voteInfo.isPreview
    },
    isLogin() {
      return this.$store.state.voteInfo.is_login
    },
  },
  methods: {
    // 初始化参数
    init() {
      this.apiParams.id = this.id;
      this.apiParams.isPreview = this.isPreview;
      this.voteText = this.$store.state.voteText;
      this.showText = this.voteText == "投票" ? "票" : "赞";
    },
    // 提醒用户当前环境
    showConfirm() {
      if ((this.isLogin == 1 && !this.isApp && !this.isWechat) || (this.isLogin == 2 && !this.isApp)) {
        this.showConfirmContent()
      }
    },
    showConfirmContent() {
      let _this = this;
      Dialog.confirm({
        title: "提示",
        message: `本页面仅提供预览，如需${_this.voteText}请点击去${_this.voteText}按钮`,
        confirmButtonText: `去${_this.voteText}`,
      }).then(() => {
        _this.launchApps();
      })
    },
    // 获取列表
    async onLoad() {
      // 异步更新数据
      if (this.isLoading) return;
      this.isLoading = true;
      let response = null;
      const orgid = this.$utils.getUrlParams("orgid");
      if (orgid) {
        let query = JSON.parse(JSON.stringify(this.$store.state.queryConfig));
        query.url = this.$apis.voteOptions;
        query.params = this.apiParams;
        query.method = "GET";
        delete query.header.jwt;
        delete query.data;
        response = await this.$fetchApi(query);
      } else {
        response = await this.$get(this.$apis.voteOptions, this.apiParams);
      }
      // console.log("OptionList选项列表res===>", response);
      if (response.data.code == "200") {
        // 仅多选有效
        this.vote_min = response.data.data.vote_min;
        this.vote_max = response.data.data.vote_max;
        // 
        this.option_type = response.data.data.option_type;
        this.number_display = response.data.data.number_display;
        //
        let data = response.data.data.list;
        if (data.length > 0) {
          this.apiParams.page++;
          this.list = this.list.concat(data);
        } else {
          this.finished = true;
        }
        this.loading = false;
        // 通过分享直接打开选项详情
        const curShowIndex = this.$utils.getUrlParams("option");
        if (curShowIndex < this.list.length && !this.hasOpened) {
          this.toVoteDetail(curShowIndex)
          this.hasOpened = true
        } else {
          this.onLoad()
        }
        // 统一图片尺寸 + 一些有的没的
        this.$nextTick(() => {
          this.initPicSize(this.data.img_type);
          $(".van-tab__pane").find(".multi-btn-group").removeClass("covered");
          $(".van-tab__pane")
            .eq(this.activeTab)
            .find(".multi-btn-group")
            .addClass("covered");
        });
      } else {
        this.$toast.fail(response.data.msg);
      }
      this.isLoading = false;
    },
    // 初始化
    initOnLoadParams(keyword) {
      this.apiParams.id = this.id;
      this.apiParams.keyword = keyword;
      this.apiParams.page = 1;
      this.loading = false;
      this.finished = false;
      this.list = [];
    },
    // 统一图片尺寸
    initPicSize(type) {
      let target = document.querySelectorAll(".option-avatar");
      if (target.length) {
        let targetWidth = parseInt(getComputedStyle(target[0]).width);
        let targetHeight = 0;
        if (type == "0") {
          targetHeight = parseInt(targetWidth * 0.75);
        } else {
          targetHeight = parseInt(targetWidth * 1.33333333);
        }
        [].forEach.call(target, (item) => {
          item.style.height = targetHeight + "px";
        });
      }
    },
    /* 搜索相关方法 */
    onSearch() {
      if (!this.apiParams.keyword) {
        this.$toast.fail("请输入搜索关键词");
        return
      }
      this.initOnLoadParams(this.apiParams.keyword);
      this.onLoad()
    },
    onClear() {
      this.initOnLoadParams("");
      this.onLoad();
      this.initOptions();
    },
    /* END 搜索相关方法 */
    /* 多选选项 */
    initOptions() {
      // console.log(this.$refs.checkboxes[0].value)
      // this.$refs.checkboxes[0].value = true
    },
    toggle(index) {
      if (this.isWechat && this.wechatPreviewOnly) {
        this.handleWeChat();
        this.multiResult = [];
        return
      }
      // this.$refs.checkboxes[index].toggle();
      this.option_ids = []; // 多选结果数组
      this.multiResult.forEach((ele) => {
        this.option_ids.push(ele.id);
      });
      console.log("多选对象", this.multiResult);
      console.log("多选结果ids", this.option_ids);
      // change UI
      // 暂时注销
      let toggledId = this.list[index]["id"];
      // console.log(this.list)
      // console.log(this.list[index])
      if (this.option_ids.indexOf(toggledId) > -1) {
        this.list[index]["btn_text"] = "已选";
      } else {
        this.list[index]["btn_text"] = "选择";
      }
      // todo 超过可选最大值时 不可再选
    },
    // 单选投票新需求
    handleSingleVote(index, ticket) {
      this.curIndex = index;
      this.ticket = ticket;
      this.getVoteStarted();
    },
    // 
    getCaptchaStarted() {
      if (this.data.captcha_mode != "0" && !this.verifyData) {
        if (this.data.captcha_mode == 1) {
          this.captchaMode = 'slide'
        }
        if (this.data.captcha_mode == 2) {
          this.captchaMode = 'text'
        }
        this.initCaptcha();
      } else {
        this.excutedVote();
      }
    },
    // 验证码
    initCaptcha() {
      let _this = this;
      _this.captcha = createCaptcha({
        appid: "vote",
        // 三种模式 默认slide滑动拼图
        mode: _this.captchaMode,
        // 验证回调
        onVerify({ error, result }) {
          // 验证失败 不需要其他额外处理，内部做了失败刷新处理
          if (error) {
          }
          // 验证成功
          if (result) {
            // result.data 返回为验证成功后的凭证
            // console.log('验证成功', result)
            _this.verifyData = result.data;
            _this.excutedVote()
            _this.captcha.destroy()
          }
        },
        // 关闭弹窗的回调
        onClose() {
          if (_this.captcha) {
            _this.captcha.destroy()
          }
        }
      })
      // 显示验证弹窗
      _this.captcha.refresh()
      _this.captcha.open();
    },
    /* 执行投票 */
    getVoteStarted() {
      // 判断是不是在客户端打开的页面
      if (this.isApp) {
        this.handleApp(this.isLogin);
      } else if (this.isWechat) {
        this.handleWeChat(this.isLogin);
      } else { // 其他浏览器环境唤起app
        this.handleOther(this.isLogin)
      }
    },
    handleApp(type) {
      if (type == 1) {
        this.getCaptchaStarted()
      } else {
        let _this = this;
        WebBridgeApi.authorize().then(({ err, result }) => {
          console.log("获取用户的基本信息res", result); // 输出结果
          if (result.user.token) {
            let query = JSON.parse(JSON.stringify(this.$store.state.queryConfig));
            query.header.jwt = result.user.token;
            _this.$store.commit("setJwt", result.user.token);
            _this.$store.commit("setQueryConfig", query);
            localStorage.setItem("voteJWT", result.user.token);
            _this.getCaptchaStarted();
            _this.initTracking(result.user.orgid, result.user.id)
            // console.log('this.$store.commit("jwt")', this.$store.state);
          }
        });
      }
    },
    // 微信内可投票，如未登录唤起网页登录
    handleWeChat(type) {
      if (type == 1) {
        this.getCaptchaStarted()
      } else if (type == 2) {
        this.showMask = true;
      } else if (type == 3) {
        this.handleWeb()
      }
    },
    // 其他环境网页登录
    handleOther(type) {
      if (type == 1 || type == 2) {
        this.launchApps()
      } else {
        this.handleWeb()
      }
    },
    // 网页登录 or 投票
    handleWeb() {
      let jwt = localStorage.getItem("voteJWT");
      if (jwt) {
        this.getCaptchaStarted();
      } else {
        // 网页登录
        this.handleWebLogin();
      }
    },
    handleWebLogin() {
      const backUrl = encodeURIComponent(window.location.href);
      const orgId = this.$store.state.voteInfo.orgidStr;
      const loginUrl = `https://app-auth.iqilu.com?orgid=${orgId}&backurl=${backUrl}`;
      window.location.replace(loginUrl);
    },
    // 投票前检查
    checkBeforeVote() {
      this.option_ids = [];
      if (this.type == "1") {
        // 单选
        // console.log("当前选项index", this.curIndex);
        this.option_ids.push(this.list[this.curIndex].id);
        this.votePayload.ticket = this.ticket;
      } else if (this.type == "2") {
        if (!this.multiResult.length) {
          this.$toast.fail("请选择投票选项");
          return;
        }
        // 多选
        if (this.multiResult.length < this.vote_min) {
          this.$toast.fail(`您勾选的内容少于${this.vote_min}个`);
          return;
        }
        if (this.multiResult.length > this.vote_max) {
          this.$toast.fail(`您勾选的内容多于${this.vote_max}个`);
          return;
        }
        this.multiResult.forEach((ele) => {
          this.option_ids.push(ele.id);
        });
        delete this.votePayload.ticket;
      }
      if (this.voteType == 1) { // 1 为组合型投票
        this.votePayload.id = this.list[0].vote_id;
      } else {
        this.votePayload.id = this.$utils.getUrlParams("id") || this.$store.state.voteInfo.id;
      }
      // 合并参数
      this.votePayload.option_ids = this.option_ids;
      this.votePayload.isPreview = this.isPreview;
      this.votePayload.verifyData = this.verifyData;
    },
    async excutedVote() {
      this.checkBeforeVote()
      if (this.isLoading) return
      this.isLoading = true;
      // 投票完成回调会用到此变量
      let voteInfo = this.popVoteInfo = this.voteType == 1 ? this.$store.state.voteInfo.vote_list[this.activeTab] : this.$store.state.voteInfo
      // console.log("执行投票 this.popVoteInfo", this.popVoteInfo)
      let query = JSON.parse(JSON.stringify(this.$store.state.queryConfig));
      query.url = this.$apis.voteSubmit + "?" + this.$urlKeyValue(this.votePayload);
      query.data = this.votePayload;
      query.method = "post";
      if (this.isLogin == 3 && this.isWechat) {
        query.header.jwt = localStorage.getItem("voteJWT");
      }
      const response = await this.$fetchApi(query);
      this.isLoading = false;
      // console.log("执行投票res", response);
      let resText = `${this.voteText}成功！`;
      let resTextDetail = '次机会'
      if (response.data.code == "200") {
        // console.log("投票成功");
        tracking.onClickButton()
        if (this.type == "1") {
          // update单选UI
          if (this.popShow) { // 选项详情界面
            this.detailParams.count = this.detailParams.count * 1 + this.ticket * 1;
          }
          this.list[this.curIndex]["btn_text"] = `已${this.voteText}`;
          this.list[this.curIndex]["count"] = this.list[this.curIndex]["count"] * 1 + this.ticket * 1;
          voteInfo.surplus_ticket = response.data.data.surplus_ticket
          voteInfo.count = Number(voteInfo.count) + this.ticket;
          resText += `您还剩余${response.data.data.surplus_ticket}${resTextDetail}`
          if (this.voteType == 1) { // 组合型投票
            this.$store.state.voteInfo.vote_list[this.activeTab] = voteInfo;
          } else {
            this.$store.state.voteInfo = voteInfo;
          }
          // 单选需要更新缓存
          // console.warn("单选投票完成之后缓存this.$store.state.voteInfo", this.$store.state.voteInfo);
          // END update单选UI
        } else if (this.type == "2") {
          // update多选UI
          this.option_ids.forEach((item) => {
            this.list.forEach((ele) => {
              if (ele.id == item) {
                ele.count++;
              }
            });
          });
          voteInfo.count = Number(voteInfo.count) + this.multiResult.length;
        }
        this.$toast.success(resText);
        setTimeout(() => {
          if (voteInfo.window_pop != 0) {
            if (voteInfo.window_pop == 1 && voteInfo.surplus_ticket >= 0 || voteInfo.window_pop == 2 && voteInfo.surplus_ticket == 0) {
              this.showModal = true
            }
          }
        }, 1000)
      } else if (response.data.code == "10029") {
        this.$toast.fail(response.data.msg);
        this.getVoteStarted();
      } else {
        this.$toast.fail(response.data.msg);
      }
      this.verifyData = "";
      this.multiResult = [];
      this.option_ids = [];
    },
    /* 展示详情 */
    toVoteDetail(index) {
      let targetUrl = this.list[index].url;
      if (targetUrl) {
        // 如果有外链链接
        // console.log("has link");
        if (targetUrl.indexOf("app-vs.iqilu.com") > -1 || targetUrl.indexOf("qiludev.com") > -1) {
        } else {
          if (this.isApp) {
            this.$webBridgeApi
              .router({
                route: "web",
                params: {
                  url: targetUrl,
                  _key: targetUrl,
                  title: "",
                },
              })
              .then(({ err, result }) => {
                console.log(" ", result, err);
              });
          } else {
            window.location.href = targetUrl;
          }
        }
      } else {
        // 查看详情，不跳外链
        /* 内页选项显示相关参数 */
        /* 
        option_id: 用接口返回的id（选项自身id）
        id：用接口返回的vote_id（活动id）
        inner_id：选项的显示顺序
        */
        this.detailParams.cover_pic = this.data.cover_pic || this.coverPic;
        this.detailParams.inner_id = this.list[index].inner_id;
        this.detailParams.pic = this.list[index].pic;
        this.detailParams.title = this.list[index].title;
        this.detailParams.count = this.list[index].count;
        this.detailParams.des = this.list[index].des;
        this.detailParams.style = this.list[index].style;
        this.detailParams.type = this.type; // 单选 or 多选
        this.detailParams.index = index; // 选项 index
        this.detailParams.activeTab = this.activeTab; // 组合投票使用 活动的第几场投票
        this.detailParams.option_type = this.option_type; // 选项类型 1 图文 2 纯文字

        // console.log("详情页入参 detailParams", this.detailParams);
        // 弹窗
        this.popShow = true;
        if (this.$utils.getUrlParams('option')) {
          console.log('有option')
          let temp = window.location.href
          // shareWexnUrl = temp.substring(0, temp.indexOf('option')) + 'option=' + index
        } else {
          console.log('没有option')
          // shareWexnUrl = window.location.href + '&option=' + index
        }
        // console.log('详情页弹窗 shareWexnUrl', shareWexnUrl)
      }
    },
    // 关闭详情弹窗
    closePop() {
      this.popShow = false;
    },
    /* END 展示详情 */
    /* 唤起APP */
    launchApps() {
      if (this.$store.state.voteInfo.org_id == 21) {
        launchAppSD()
        return
      }
      launchApp()
    },
    // 唤起闪电
    // 设置埋点公共属性
    initTracking(orgid, memberid) {
      window.collectEvent('config', {
        app_org_id: orgid,
        app_org_cate: orgid,
        app_org_id1: orgid,
        app_org_id2: orgid,
        app_org_id3: orgid,
        // 当前登录用户id
        user_unique_id: memberid,
        business_name: '投票'
      })
    },
    // 20221221
    showAllTickets() {
      if (this.$utils.getUrlParams("id") == 'NTAxOjU1Y2Jh' || this.$utils.getUrlParams("id") == 'NDcxNTphNWEyNQ') {
        return false
      }
      return true
    },
    // 关闭投票后弹窗
    handleClosePopAfter() {
      this.showModal = false
    }
  },
  created() {

  },
  mounted() {
    this.init()
    this.onLoad();
    this.showConfirm()
  }
};
</script>

<style scoped lang="less">
.option-list-container {
  min-height: 10rem;
  height: 100%;
  padding-bottom: 50px;

  .van-icon.van-icon-search {
    display: none;
  }

  .search-container {
    display: flex;
    border: 0.01rem solid var(--themeColor);
    border-radius: 0.35rem;
    overflow: hidden;
    height: 0.7rem;
    width: 85%;
    margin: 0.4rem auto 0;

    .van-search {
      flex: 1;
      padding: 0;
      background: #fff;
    }

    .van-search__content {
      background: #fff;
    }

    .search-btn {
      width: 1.4rem;
      height: 100%;
      line-height: 0.6rem;
      font-size: 0.34rem;
      border-radius: 0.3rem;
      background-color: var(--themeColor);
      background-image: url(../assets/images/btn-search.png);
      background-position: center center;
      background-repeat: no-repeat;
      background-size: 0.34rem;
    }
  }

  .vote-summary-container {
    margin: 0;
  }

  .no-cnt {
    height: 8rem;
    background: url(../assets/images/bg-no-cnt.png) center center/3.5rem no-repeat;
  }

  .open_browser {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.75);
    z-index: 9999;

    p {
      text-align: center;
      margin-top: 1rem;
      font-size: 0.36rem;
      color: #fff;
    }

    img {
      position: absolute;
      top: 0.5rem;
      left: 0;
      right: 0;
      margin: auto;
      width: 5.88rem;
    }
  }

  .van-popup--right {
    width: 100%;
    height: 100%;
  }
}
</style>